import React, { useState, useEffect, useRef, useMemo } from "react";
import { useQuery, useQueryClient } from "react-query";
import {
  fetchDeals,
  fetchOpenPositions,
} from "../../../services/main.service.ts";
import Paginator from "../../composites/paginator.tsx";
import WithAuth from "../../hoc/with-auth.tsx";
import { LayoutWithSidebar } from "../../layouts/layout-with-sidebar.tsx/index.tsx";
import {
  Badge,
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Grid,
  GridItem,
  Button,
  Link as CLink,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Select,
} from "@chakra-ui/react";
import _ from "lodash";
import BlockedLoader from "../../composites/blocked-loader.tsx";
import DateRangePicker from "../../composites/date-range-picker.tsx";
import { AiOutlineSearch } from "react-icons/ai";
import { Input, InputWrapper } from "../../composites/index.tsx";
import { ReactSelect } from "../../composites/select.tsx";
import { SelectSymbols } from "../../composites/select-symbols.tsx";
import { CSVLink, CSVDownload } from "react-csv";
import { AiOutlineDownload } from "react-icons/ai";
import {
  createSharingLogicService,
  fetchCommissionLogicService,
  getTradesByIPService,
} from "../../../services/sql.service.ts";
import { FaPlus, FaDownload, FaSearch } from "react-icons/fa";
import { useFormik } from "formik";
import { useShowToastHook } from "../../../hooks/show-toast-hook.ts";
import {
  getAllDepositsAndWithdrawalOfAUser,
  getTradeHistoryOfAllUsers,
} from "../../../services/crm.service.ts";
import { endOfDayDate, formatDate } from "../../../utils/formatDate.ts";
import { da } from "date-fns/locale";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { downloadCsv } from "../../../utils/downloadCSV.ts";

const captions = [
  "IP Addresss",
  "Deal",
  "Position",
  "Login",
  "Name",
  "Time",
  "Entry",
  "Symbol",
  "Volume",
  "Price",
  "S/L",
  "T/P",
  "Reason",
  "Profit",
  "Dealer",
  "Comment",
];

const getParam = (name: string) => {
  let params = new URLSearchParams(window.location.search ?? "");

  console.log(params.get(name));

  return params.get(name) ?? "";
};

const formatSecondsToDate = (_t: any) => {
  return moment.unix(_t).format("DD-MM-YYYY hh:mm:ss A");
};

const CreditFacilityPage = () => {
  const [[startDate, endDate], setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([new Date(), new Date()]);
  const [loginId, setLoginId] = useState(getParam("login"));

  const [currentPage, setCurrentpage] = useState(1);

  const [finalState, setFinalState] = useState<{
    loginId: string;

    startDate: Date | undefined;
    endDate: Date | undefined;
  }>({
    loginId: loginId,
    startDate: startDate,
    endDate: endDate,
  });

  const updateFinalState = () => {
    setFinalState({
      loginId,
      startDate,
      endDate,
    });
  };

  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
    error,
    refetch,
  } = useQuery(
    [
      "login-deposit-and-withdrawal" + loginId,
      {
        currentPage,
        finalState,
      },
    ],
    () =>
      getAllDepositsAndWithdrawalOfAUser(
        finalState.startDate ? formatDate(finalState.startDate) : "",
        // @ts-ignore
        finalState.endDate ? formatDate(endOfDayDate(finalState.endDate)) : "",
        finalState.loginId ?? "",
        3
      ),
    {
      refetchInterval: 15000,
    }
  );

  const gridRef = useRef<any>(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row

  const [columnDefs, setColumnDefs] = useState([
    { headerName: "Deal", field: "dealId" },
    { headerName: "Login", field: "loginId" },
    { headerName: "Time", field: "time" },
    { headerName: "Type", field: "type" },
    { headerName: "Comment", field: "comment" },
    { headerName: "Amount", field: "profit" },
  ]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      // make every column editable
      editable: false,
      selectable: true,
      // make every column use 'text' filter by default
      filter: "agTextColumnFilter",
      // enable floating filters by default
      floatingFilter: true,
      // make columns resizable
      resizable: true,
      // disable cell data types
      cellDataType: false,
      sortable: true,
    }),
    []
  );

  const rows = useMemo(() => {
    let rows: any = [];

    if (!_.isEmpty(data?.data?.data)) {
      rows = _.map(data?.data?.data, (_d) => {
        return {
          ..._d,
          type: _d?.profit > 0 ? "CREDIT IN" : "CREDIT OUT",
          time: formatSecondsToDate(_d?.time),
        };
      });
    }

    return rows;
  }, [data, isLoading]);

  const handleDownload = () => {
    if (rows?.length) {
      const rowsToDownload = _.map(rows, (_row) => {
        return {
          Deal: _row?.dealId,
          Login: _row?.loginId,
          Time: _row?.time,
          Type: _row?.type,
          Comment: _row?.comment,
          Amount: _row?.profit,
        };
      });

      downloadCsv(
        rowsToDownload,
        `deposit-and-withdrawal-${finalState.startDate}-to-${finalState.endDate}.csv`
      );
    }
  };

  return (
    <>
      <Grid
        templateColumns={[
          "repeat(1, 1fr)",
          "repeat(2, 1fr)",
          "repeat(3, 1fr)",
          "repeat(4, 1fr)",
          "repeat(5, 1fr)",
        ]}
        gap={6}
        mt={4}
      >
        <Box>
          <Input
            title="Login"
            placeholder="Enter login"
            value={loginId}
            onChange={(e) => {
              setLoginId(e?.target?.value);
            }}
          />
        </Box>

        <Box position="relative">
          <Box my={-4}>
            <DateRangePicker
              startDate={startDate}
              endDate={endDate}
              setDateRange={setDateRange}
            />
          </Box>
        </Box>

        <Box position="relative"> </Box>

        <Box position="relative"> </Box>

        <Box position="relative">
          <Flex align="flex-end" justify="flex-end">
            <Box pt={[0, "24px"]} pr={4}>
              <Button
                colorScheme="blue"
                mr={4}
                onClick={handleDownload}
                isDisabled={!rows?.length}
              >
                <Box as={FaDownload} />
              </Button>

              <Button
                colorScheme="blue"
                onClick={() => {
                  setFinalState({
                    loginId: loginId,
                    startDate: startDate,
                    endDate: endDate ? endDate : startDate,
                  });
                }}
              >
                <Box as={FaSearch} mr={2} />
                Search
              </Button>
            </Box>
          </Flex>
        </Box>
      </Grid>
      <Box textAlign="right" my={4}></Box>
      <Box my={4}>
        <div className="ag-grid-container">
          <div
            className="ag-theme-alpine"
            style={{ width: "100%", height: "calc(100vh - 100px)" }}
          >
            <AgGridReact
              suppressScrollOnNewData={true}
              ref={gridRef} // Ref for accessing Grid's API
              rowData={rows ?? []} // Row Data for Rows
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              overlayNoRowsTemplate={
                isLoading ? "Loading transactions..." : "No transactions found"
              }
            />
          </div>
        </div>
      </Box>
    </>
  );
};

export default CreditFacilityPage;

function getUpcomingMondays() {
  const today = new Date();
  const currentYear = today.getFullYear();
  const upcomingMondays = [];

  // Set the date to January 1st of the current year
  today.setMonth(0, 1);

  // Find the first Monday in the year
  while (today.getDay() !== 1) {
    today.setDate(today.getDate() + 1);
  }

  // Add only upcoming Mondays to the array
  while (today.getFullYear() === currentYear) {
    if (today.getTime() > Date.now()) {
      upcomingMondays.push(new Date(today.getTime()));
    }
    today.setDate(today.getDate() + 7);
  }

  return upcomingMondays;
}

function formatDateToDDMMYYYY(date: Date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}
